<script setup lang="ts">
/**
 * Page /auth/callback
 * DartsHub redirige ici après connexion SSO avec les tokens dans le fragment URL :
 * https://compet.dartshub.fr/auth/callback#token=xxx&refresh=yyy&email=...
 */
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/useAuthStore';

const router = useRouter();
const authStore = useAuthStore();

onMounted(async () => {
  const hash = window.location.hash.slice(1);
  if (!hash) {
    router.replace('/');
    return;
  }

  const params = new URLSearchParams(hash);
  const token = params.get('token');

  if (!token) {
    router.replace('/');
    return;
  }

  try {
    authStore.setFromCallback(params);
    await Promise.all([authStore.fetchCurrentUser(), authStore.fetchLicense()]);
  } catch (e) {
    console.error('AuthCallback error:', e);
  }

  const returnTo = new URLSearchParams(window.location.search).get('return_to') || '/';
  history.replaceState(null, '', window.location.pathname);
  router.replace(returnTo);
});
</script>

<template>
  <div class="callback-loader">
    <i class="fa-solid fa-spinner fa-spin" />
    <span>Connexion en cours…</span>
  </div>
</template>

<style scoped>
.callback-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 1rem;
  color: var(--text-muted);
  font-size: 1.1rem;
}
</style>
